module.exports = __webpack_public_path__ + "static/img/bah.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/bah.png
// module id = TVDp
// module chunks = 1